export const getCurrentSession = async (): Promise<string> => {
  console.debug("[Service] getCurrentSession", {});
  const user: Parse.User | null = await Parse.User.currentAsync();

  return user?.getSessionToken() as string;
};
